import React, { useEffect } from 'react';
import { PageProps } from './page.models';

export const Page = ({ title, description, children, style, pageScript }: PageProps): JSX.Element => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    if (description) {
      const metaDescription = document.querySelector('meta[name="description"]');

      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        const newMetaDescription = document.createElement('meta');
        newMetaDescription.setAttribute('name', 'description');
        newMetaDescription.setAttribute('content', description);
        document.head.appendChild(newMetaDescription);
      }
    }
  }, [title, description]);

  useEffect(() => {
    if (style) {
      const styleTag = document.createElement('style');
      styleTag.setAttribute('type', 'text/css');
      styleTag.innerHTML = style;
      document.head.appendChild(styleTag);
    }
  }, [style]);

  useEffect(() => {
    if (pageScript) {
      const scriptTag = document.createElement('script');
      scriptTag.setAttribute('async', 'true');
      scriptTag.setAttribute('src', pageScript);
      document.head.appendChild(scriptTag);
    }
  }, [pageScript]);

  return (
    <>{children}</>
  );
};
